import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import InternalTemplate from '../../../../components/templates/internal';
import {NotificationsItem} from '../../../../components/notifications';
import {INotification} from '../../../../interfaces/dtos';
import {StackParamList} from '../../../../navigators';
import {useContextState as userContext} from '../../../../context/user';
import {SpinnerModal} from '../../../../components/modals';
import {EmptyListIcon} from '../../../../components/icons';

type ScreenProps = NativeStackScreenProps<StackParamList, 'Notifications'>;

interface INotificationContent {
  isLoading: boolean;
  notifications: INotification[] | null;
  labelColor: string;
}

const NotificationContent = ({
  isLoading,
  notifications,
  labelColor,
}: INotificationContent) => {
  if (isLoading) {
    return <></>;
  }
  if (notifications) {
    if (notifications?.length === 0) {
      return <EmptyListIcon />;
    }
    return (
      <>
        {notifications.map((message: INotification, index: number) => (
          <NotificationsItem
            key={`message-item-${index}`}
            unread={message.unread}
            color={labelColor}
            title={message.title}
            summary={message.body}
          />
        ))}
      </>
    );
  }

  return <></>;
};

const NotificationsScreen = ({navigation}: ScreenProps) => {
  const {
    notifications,
    fetchNotificationList,
    getDashboardScreenName,
    markNotificationsRead,
  } = userContext();
  const [isLoading, setIsLoading] = useState(false);

  const getNotifications = async () => {
    setIsLoading(true);
    await fetchNotificationList(true);
    setIsLoading(false);
  };

  useEffect(() => {
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const labelColor = '#05375a';

  const handleGoBack = () => {
    markNotificationsRead();
    const screenName = getDashboardScreenName();
    navigation.navigate(screenName);
  };

  return (
    <InternalTemplate
      title={'screen-notifications-title'}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <>
        <SpinnerModal show={isLoading} />
        <NotificationContent
          isLoading={isLoading}
          notifications={notifications}
          labelColor={labelColor}
        />
        <Box marginBottom="50%">
          <></>
        </Box>
      </>
    </InternalTemplate>
  );
};
export default NotificationsScreen;
